"use client";

import { c as _c } from "react/compiler-runtime";
import { CommandBar } from "@/components/command-bar";
import { ProgressBarLink } from "@/components/progress-bar";
import { SidebarHeader as ShadcnSidebarHeader } from "@/components/ui/sidebar";
import { useEnterprise } from "@/contexts/enterprise-provider";
import { useTenant } from "@/contexts/tenant-provider";
import { useTheme } from "@/contexts/theme-provider";
export function SidebarHeader(t0) {
  const $ = _c(12);
  const {
    tourAnchors
  } = t0;
  const {
    resolvedTheme
  } = useTheme();
  const enterprise = useEnterprise();
  const {
    tenant
  } = useTenant();
  const isDefaultDecodaLogo = !enterprise?.logoUrl || enterprise.logoUrl === "/logos/decoda-logo.png";
  const logoUrl = isDefaultDecodaLogo ? resolvedTheme === "dark" ? "/logos/decoda-logo-bp-white.png" : "/logos/decoda-logo.png" : enterprise.logoUrl;
  const t1 = tenant?.homePage ?? "/";
  const t2 = `${enterprise?.name ?? "Default"} logo`;
  let t3;
  if ($[0] !== logoUrl || $[1] !== t2) {
    t3 = <img src={logoUrl} alt={t2} className="h-8 w-auto max-w-[180px] object-contain transition-all duration-200" />;
    $[0] = logoUrl;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t1 || $[4] !== t3) {
    t4 = <div className="flex items-center justify-center p-4 transition-all duration-200"><ProgressBarLink href={t1}>{t3}</ProgressBarLink></div>;
    $[3] = t1;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = tourAnchors ? "tour-train-search" : undefined;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <CommandBar />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5) {
    t7 = <div id={t5} className="w-full transition-all duration-200 px-4">{t6}</div>;
    $[7] = t5;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t4 || $[10] !== t7) {
    t8 = <ShadcnSidebarHeader className="gap-0 p-0">{t4}{t7}</ShadcnSidebarHeader>;
    $[9] = t4;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}